import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html',
  styleUrls: ['./page-notfound.component.css']
})
export class PageNotfoundComponent implements OnInit {

  constructor(public jwtHelper: JwtHelperService, private router: Router) { }
landingPage:any;
  ngOnInit() {
    if (!this.jwtHelper.isTokenExpired()) {
      if(localStorage.getItem("type")=="1")
       this.landingPage="/client-apps";
       else
       this.landingPage="/dashboard";
      this.router.navigate(['/page-not-found'])
    }
    // this.model.gender = "Gender"
  }
}


